// Import all validation utilities
const validation = require('./validation');

/**
 * Sanitizes text for use in filenames or slugs
 * @param {string} text - The text to sanitize
 * @param {boolean} preserveCase - Whether to preserve the original case (default: false)
 * @returns {string} - Sanitized text
 */
const sanitizeForUrl = (text, preserveCase = false) => {
   if (!text) return '';
  
  let result = text
    .trim()
    .replace(/\s+/g, '-')         // Replace spaces with -
    .replace(/&/g, '-and-')       // Replace & with 'and'
    .replace(/[^\w\-]+/g, '')     // Remove all non-word chars except hyphens
    .replace(/\-\-+/g, '-')       // Replace multiple - with single -
    .replace(/^-+/, '')           // Trim - from start of text
    .replace(/-+$/, '');          // Trim - from end of text
    
  if (!preserveCase) {
    result = result.toLowerCase();
  }
  return result;
};

// Re-export utilities for CommonJS (Node.js backend)
module.exports = {
  ...validation,
  sanitizeForUrl
};